import React from 'react';

import { ModalIconClose } from 'ui/lexus/components';
import { isIOS } from 'utils';

import styles from './styles';

const {
    ModalContent,
    ModalClose,
    ModalTitle,
    ModalBody,
    ModalText,
    ModalList,
    ModalTextContainer,
    ButtonNext,
    Modal,
} = styles;

const DEFAULT_TITLE = 'Заголовок по-умолчанию';

export class ModalDealerCenter extends React.Component {
    componentDidMount() {
        const overflowClass = isIOS() ? 'overflowIOS' : 'overflow';
        document.querySelector('body').classList.add(overflowClass);
    }

    componentWillUnmount() {
        const overflowClass = isIOS() ? 'overflowIOS' : 'overflow';
        document.querySelector('body').classList.remove(overflowClass);
    }

    goBackPage = () => {
        window.history.back();
    };

    render() {
        const {
            title, content, onClose,
            name, error, task,
        } = this.props;

        return (
            <Modal error={error}>
                <ModalContent error={error} task={task}>
                    <ModalClose onClick={() => error ? this.goBackPage() : onClose(name)}>
                        <ModalIconClose />
                    </ModalClose>
                    <ModalBody>
                        <ModalTitle>{title || DEFAULT_TITLE}</ModalTitle>
                        <ModalTextContainer content={content} error={error}>
                            <ModalText>
                                <ModalList error={error}>
                                    {content.map(part => (
                                        <>
                                            <li key={content.indexOf(part)} dangerouslySetInnerHTML={{__html: part}}/>
                                            <br />
                                        </>
                                    ))}
                                </ModalList>
                            </ModalText>
                        </ModalTextContainer>
                        <ButtonNext onClick={() => error ? this.goBackPage() : onClose(name)}>Закрыть</ButtonNext>
                    </ModalBody>
                </ModalContent>
            </Modal>
        );
    }
}

export default ModalDealerCenter;
